import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './core/components/login/login.component';

// Guard
import { authGuard } from './core/guard/auth.guard';
import { MainLayoutComponent } from './shared/main-layout/main-layout.component';
import { RecoverPasswordComponent } from './core/components/recover-password/recover-password.component';
import { DashboardMenuComponent } from './pages/dashboards/dashboard-menu/dashboard-menu.component';
import { FinantialExpensesReportComponent } from './pages/reports/finantial-expenses-report/finantial-expenses-report.component';
import { FinantialReportComponent } from './pages/reports/finantial-report/finantial-report.component';
import { pageAccessGuard } from './pages/guard/page-access.guard';
import { InvoicePageComponent } from './features/invoice/presentation/pages/invoice-page/invoice-page.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'recuperar-senha', component: RecoverPasswordComponent },
  {
    path: 'painel-gestor',
    loadChildren: () =>
      import('./pages/management-panel/management-panel.module').then(
        (m) => m.ManagementPanelModule
      )
      /*,
      canActivate: [pageAccessGuard],
      data: {
        access: 'management-panel'
      }*/
  },
  {
    path: '',
    canActivate: [authGuard],
    canActivateChild: [authGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'cadastros',
        loadChildren: () =>
          import('./modules/register/register.module').then(
            (m) => m.RegisterModule
          )
      },
      {
        path: 'profissionais',
        loadChildren: () =>
          import('./modules/professional/professional.module').then(
            (m) => m.ProfessionalModule
          )
      },
      {
        path: 'notas-fiscais',
        component: InvoicePageComponent,
        canActivate: [pageAccessGuard],
        data: {
          access: 'notaFiscal'
        }
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./pages/home/home.module').then((m) => m.HomeModule),
        canActivate: [pageAccessGuard],
          data: {
            access: 'home'
          }
      },
      {
        path: 'cadastro',
        loadChildren: () =>
          import('./pages/cadastro/cadastro.module').then(
            (m) => m.CadastroModule
          ),
      },
      {
        path: 'financeiro',
        loadChildren: () =>
          import('./pages/financeiro/financeiro.module').then(
            (m) => m.FinanceiroModule
          ),
      },
      {
        path: 'cadastro/forma-pagamento',
        loadChildren: () =>
          import('./pages/forma-pagamento/forma-pagamento.module').then(
            (m) => m.FormaPagamentoModule
          ),
          canActivate: [pageAccessGuard],
          data: {
            access: 'formaPagamento'
          }  
      },
      {
        path: 'cadastro/servico',
        loadChildren: () =>
          import('./pages/servicos/servicos.module').then(
            (m) => m.ServicosModule
          ),
          canActivate: [pageAccessGuard],
          data: {
            access: 'servicos'
          }  
      },
      {
        path: 'cadastro/contabilidade',

        loadChildren: () =>
          import('./pages/contabilidade/contabilidade.module').then(
            (m) => m.ContabilidadeModule
          ),
          canActivate: [pageAccessGuard],
          data: {
            access: 'contabilidade'
          }
          
      },
      {
        path: 'cadastro/dados',

        loadChildren: () =>
          import('./pages/dados/dados.module').then((m) => m.DadosModule),
        canActivate: [pageAccessGuard],
          data: {
            access: 'dadosCadastro'
          } 
      },
      {
        path: 'entrega-exame',
        loadChildren: () =>
          import('./pages/release-exam/release-exam.module').then(
            (r) => r.ReleaseExamModule
          ),
          canActivate: [pageAccessGuard],
          data: {
            access: 'entregaExame'
          }  
      },
      {
        path: 'relatorios',
        loadChildren: () =>
          import('./pages/reports/reports.module').then(
            (m) => m.ReportsModule
          ),
      },
      {
        path: 'agenda',
        loadChildren: () =>
          import('./pages/schedule/schedule.module').then(
            (m) => m.ScheduleModule
          ),
          canActivate: [pageAccessGuard],
          data: {
            access: 'agenda'
          }
      },
      {
        path: 'resultado-profissional',
        loadChildren: () =>
          import('./pages/professional-result/professional-result.module').then(
            (m) => m.ProfessionalResultModule
          ),
          canActivate: [pageAccessGuard],
          data: {
            access: 'resultado-profissional'
          }
      },
      {
        path: 'avaliacao',
        loadChildren: () =>
          import('./pages/rating/rating.module').then((r) => r.RatingModule) 
      },
      {
        path: 'solicitacao-cliente',
        loadChildren: () =>
          import('./pages/customer-request/customer-request.module').then((c) => c.CustomerRequestModule) 
      }
    ],
  },

  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }

// {
// path: '',
// component: MainLayoutComponent,
// children: [
//   { path: 'cadastro/funcionarios', component: ListaFuncionariosComponent },
//   {
//     path: 'cadastro/funcionarios/cadastrar',
//     component: CadastrarFuncionariosComponent,
//   },
//   {
//     path: 'cadastro/profissionais',
//     component: ListaProfissionaisComponent,
//   },
//   {
//     path: 'cadastro/profissionais/cadastrar',
//     component: CadastrarProfissionaisComponent,
//   },
// ],
// },
